<template>
    <div>
        <div class="" id="brand_link">
            <button
                class="category_link w-100 d-flex justify-content-center align-items-center"
                :class="{ collapsed: !active, show: active }"
                type="button"
                data-toggle="collapse"
                :data-target="`#attribute_div_${id}`"
                aria-expanded="false"
                aria-controls="collapseOne"
            >
                <span>{{ name }}</span>
                <img
                    src="/maincss/images/plusplus.svg"
                    alt=" "
                    class="ml-auto arrow_accordion"
                />
                <img
                    src="/maincss/images/dashh.svg"
                    alt=" "
                    class="ml-auto arrow_accordion_white"
                />
            </button>
        </div>
        <div
            :id="`attribute_div_${id}`"
            class="category_checkbox_show collapse"
            :class="{ show: active }"
            aria-labelledby="brand_link"
            data-parent="#accordionExample"
        >
            <div
                class="d-flex pl_8 py_6 align-items-center pms_filter"
                v-if="id == 'ColorShades'"
            >
                <label class="font-weight-bold mt-2">PMS</label>
                <input
                    class="ml-2 pms_filter_input"
                    type="text"
                    placeholder="E.g. 2133c"
                    v-model="pmsSearch"
                    @keyup.enter="
                        $emit(
                            'filterProducts',
                            { target: { checked: true } },
                            $event.target.value,
                            'pms',
                            'pms',
                            'pms'
                        )
                    "
                />
                <img
                    style="cursor: pointer"
                    @click="
                        $emit(
                            'filterProducts',
                            { target: { checked: true } },
                            pmsSearch,
                            'pms',
                            'pms',
                            'pms'
                        )
                    "
                    width="20"
                    src="/maincss/images/icons/magnifying-glass.svg"
                    alt="logo"
                    class="headerlogo ml-3 search_icon"
                />
            </div>
            <div class="category_checkbox" v-if="options.length > 0">
                <div
                    class="form-check pl_8 py_6"
                    v-for="(option, option_index) in options"
                    :key="option_index"
                    v-show="showMoreOptions ? true : option_index < 4"
                >
                    <label
                        class="checkbox_custom d-table"
                        v-if="id == 'Prices'"
                    >
                        ${{ option.from }} - ${{ option.to }}
                        <input
                            type="checkbox"
                            :checked="
                                config[type].find(
                                    (range) =>
                                        range.to == option.to &&
                                        range.from == option.from
                                )
                            "
                            @change="
                                $emit(
                                    'filterProducts',
                                    $event,
                                    option,
                                    type,
                                    id,
                                    option[optionLabel]
                                )
                            "
                        />
                        <span class="checkmark"></span>
                        <!-- ({{ option.products_count || 0 }}) -->
                    </label>
                    <label class="checkbox_custom d-table" v-else>
                        <span
                            v-if="option.colors && option.colors.length"
                            @click="
                                $event.preventDefault();
                                prepareNestedSelectedOptions();
                            "
                            data-toggle="modal"
                            :data-target="`#option-${type}-${option.id}`"
                        >
                            <u>{{ option[optionLabel] | capitalize }}</u>
                        </span>
                        <span v-else>{{
                            option[optionLabel] | capitalize
                        }}</span>
                        <input
                            :id="option.id"
                            :value="option.id"
                            :checked="config[type].includes(option[storeKey])"
                            type="checkbox"
                            @change="
                                $emit(
                                    'filterProducts',
                                    $event,
                                    option[storeKey],
                                    type,
                                    id,
                                    option[optionLabel]
                                )
                            "
                        />
                        <span class="checkmark"></span>
                        <!-- ({{ option.products_count || 0 }}) -->
                    </label>

                    <!-- SUB MENUS POPUP-->
                    <div
                        v-if="option.colors && option.colors.length"
                        class="modal fade"
                        :id="`option-${type}-${option.id}`"
                        tabindex="-1"
                        aria-labelledby="termsAndConditions"
                        aria-hidden="true"
                        data-keyboard="false"
                        data-backdrop="static"
                    >
                        <div
                            class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
                        >
                            <div class="modal-content">
                                <div class="modal-body">
                                    <a
                                        href="#"
                                        class="popup-close art_poup_close"
                                        id="popup-close"
                                        data-dismiss="modal"
                                    >
                                        <img
                                            src="/maincss/images/cancel.svg"
                                            v-tooltip="'Close'"
                                            alt=" "
                                        />
                                    </a>
                                    <div class="p-2 mb-3">
                                        <label class="checkbox_custom d-table">
                                            Select all
                                            <input
                                                type="checkbox"
                                                v-model="option.select_all"
                                                @change="
                                                    selectAll($event, option)
                                                "
                                            />
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="d-flex flex-wrap p-2">
                                        <div
                                            class="mb-4"
                                            style="flex-basis: 33%"
                                            v-for="(
                                                color, color_index
                                            ) in option.colors"
                                            :key="color_index"
                                        >
                                            <label
                                                class="checkbox_custom d-table"
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    class="color_circle mr_6"
                                                    :style="
                                                        color.swatches
                                                            ? 'background-image:url(' +
                                                              color.swatches +
                                                              ')'
                                                            : ' background-color:' +
                                                              color.hex
                                                    "
                                                ></a>
                                                {{ color["name"] | capitalize }}
                                                <input
                                                    :id="color.id"
                                                    :value="color.id"
                                                    type="checkbox"
                                                    v-model="color.selected"
                                                    @change="
                                                        selectNestedOptions(
                                                            $event,
                                                            option
                                                        )
                                                    "
                                                />
                                                <span class="checkmark"></span>
                                                <!-- ({{ color.products_count || 0 }}) -->
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button
                                        v-if="
                                            selected_nested_options[
                                                option.name
                                            ] &&
                                            selected_nested_options[option.name]
                                                .length > 0
                                        "
                                        class="btn btn_orange bg_primary_orange text_white mx_6"
                                        type="button"
                                        @click="clearNestedOptions(option)"
                                    >
                                        Clear
                                    </button>
                                    <button
                                        class="btn btn_orange bg_primary_orange text_white mx_6"
                                        type="button"
                                        data-dismiss="modal"
                                        @click="
                                            submitNestedOptions(option.name)
                                        "
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <a
                    v-show="options.length > 4"
                    @click="$emit('showMore')"
                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                >
                    {{ showMoreOptions ? "See less" : "See more" }}
                </a>

                <a
                    v-if="checkCountOfOptions()"
                    @click="clearFilters(type, id)"
                    class="font_size_13 text-danger btn_link mt_14 pl_8 pb-0"
                >
                    Clear All
                </a>
            </div>
            <div class="category_checkbox" v-else>
                <div class="form-check pl_8 py_6 h6">No options found</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "AttributeFilter",
    props: {
        id: {
            required: true
        },
        name: {
            required: true
        },
        index: {
            required: true
        },
        type: {
            required: true
        },
        options: {
            required: true,
            default: () => []
        },
        showMoreOptions: {
            default: () => false
        },
        optionLabel: {
            default: () => "name"
        },
        active: {
            default: () => false
        },
        storeKey: {
            default: () => "id"
        },
        config: {}
    },
    data() {
        return {
            selected_nested_options: {},
            pmsSearch: ""
        };
    },
    watch: {
        config: {
            handler() {
                if (this.id == "ColorShades") {
                    this.prepareNestedSelectedOptions();
                }
                this.$forceUpdate();
            },
            deep: true
        }
    },
    methods: {
        prepareNestedSelectedOptions() {
            this.selected_nested_options = {};
            this.options.forEach((shade) => {
                let selectedColorIds = [];
                shade.colors.forEach((color) => {
                    if (this.config["colorIds"].includes(color.id)) {
                        color.selected = true;
                        selectedColorIds.push(color.id);
                    } else {
                        color.selected = false;
                    }
                });
                if (
                    shade.colors &&
                    shade.colors.length == selectedColorIds.length
                ) {
                    shade.select_all = true;
                } else {
                    if (shade.select_all) {
                        shade.select_all = false;
                    }
                }
                if (selectedColorIds.length > 0) {
                    this.selected_nested_options[shade.name] = selectedColorIds;
                }
            });
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        checkCountOfOptions() {
            if (this.type == "attribute_options") {
                let option_ids = this.options.map((option) => option.id);
                let filter_option_ids = this.config[this.type].filter(
                    (filterId) => option_ids.includes(filterId)
                );
                return filter_option_ids.length > 0;
            }
            return this.config[this.type].length > 0;
        },
        selectNestedOptions(event, option) {
            if (event.target.checked) {
                if (!this.selected_nested_options[option.name]) {
                    this.selected_nested_options[option.name] = [
                        parseInt(event.target.value)
                    ];
                } else {
                    this.selected_nested_options[option.name].push(
                        parseInt(event.target.value)
                    );
                }
            } else {
                if (this.selected_nested_options[option.name]) {
                    this.selected_nested_options[option.name] =
                        this.selected_nested_options[option.name].filter(
                            (nestedOption) =>
                                nestedOption != parseInt(event.target.value)
                        );
                    option.select_all = false;
                }
            }
            option.select_all =
                this.selected_nested_options[option.name] &&
                option.colors.length ==
                    this.selected_nested_options[option.name].length;

            this.$forceUpdate();
        },
        clearNestedOptions(optionObj) {
            delete this.selected_nested_options[optionObj.name];
            optionObj.select_all = false;
            optionObj.colors.forEach((color) => {
                color.selected = false;
            });
            this.$forceUpdate();
        },
        selectAll(event, optionObj) {
            if (event.target.checked) {
                optionObj.select_all = true;
                optionObj.colors.forEach((color) => {
                    color.selected = true;
                });
                this.selected_nested_options[optionObj.name] =
                    optionObj.colors.map((nestedOption) =>
                        parseInt(nestedOption.id)
                    );
            } else {
                this.clearNestedOptions(optionObj);
            }
            this.$forceUpdate();
        },
        clearFilters(type, id) {
            this.$emit("clearFilters", type, id);
        },
        submitNestedOptions(shade) {
            let color_ids = [];
            /* eslint-disable */
            this.config["colorShades"] = [];
            for (const [color_shade, colors] of Object.entries(
                this.selected_nested_options
            )) {
                color_ids = color_ids.concat(colors);
                // Remove shades colors if select_all is not present
                let selectAllFlag = this.options.filter(obj => 'select_all' in obj).map(obj => obj['select_all']);
                if (!selectAllFlag){
                     if (colors.length > 0) {
                        this.config["colorShades"].push(color_shade);
                    }
                }
            }
            this.config["colorIds"] = [...new Set(color_ids)];
            /* eslint-enable */
            let checked =
                this.selected_nested_options[shade] &&
                this.selected_nested_options[shade].length > 0;
            this.$emit(
                "filterProducts",
                { target: { checked: checked } },
                shade,
                this.type,
                this.id,
                shade
            );

            this.$forceUpdate();
        }
    }
};
</script>
